export default () => ({
  submit(event) {
    event.currentTarget.form?.requestSubmit()
  }
})
